import { render } from "./riskpopup.vue?vue&type=template&id=7af7f1d9&scoped=true"
import script from "./riskpopup.vue?vue&type=script&lang=js"
export * from "./riskpopup.vue?vue&type=script&lang=js"

import "./riskpopup.vue?vue&type=style&index=0&id=7af7f1d9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af7f1d9"]])

export default __exports__